// invoiceGeneralInfoModel.js

import { readNodeFieldRawValue } from 'utilities/NodeFieldData';

export const INVOICE_TYPE_KEY = 'INVOICE';
export const INVOICE_ITEM_TYPE_KEY = 'INVOICE_ITEM';

function normalizeString(value) {
  return String(value || '').trim();
}

export function resolveInvoiceTypeKey(node, nodeType = null) {
  return normalizeString(nodeType?.key || node?.type).toUpperCase() || INVOICE_TYPE_KEY;
}

export function readInvoiceField(node, fieldName, nodeType = null) {
  const typeKey = resolveInvoiceTypeKey(node, nodeType);
  return readNodeFieldRawValue(
    node,
    { name: fieldName, source: typeKey.toLowerCase() },
    typeKey,
  );
}
